import { render } from "./InputForm.vue?vue&type=template&id=d11c7300"
import script from "./InputForm.vue?vue&type=script&lang=js"
export * from "./InputForm.vue?vue&type=script&lang=js"
script.render = render

export default script